export default "__VITE_ASSET__oqlQ1K3I__"